import React from 'react';
import { MealBuilderLayout } from 'components/MealBuilder';

export const ShoppingPage: React.FC = () => {
  return <MealBuilderLayout />;
};
